import { Component, EventEmitter, Output } from "@angular/core";
import { Router } from "@angular/router";
import { NavigationHelper } from "../../services/navigation.helper";

@Component({
  selector: "mobile-menu",
  templateUrl: "./mobile-menu.component.html",
  styleUrls: ["./mobile-menu.component.css"],
})
export class MobileMenuComponent {
  @Output() itemSelected = new EventEmitter<string>();
  @Output() toggleMenu = new EventEmitter<void>();
  @Output() backClicked = new EventEmitter<void>();
  currentScreen: number = 0;
  constructor(private router: Router, private nav: NavigationHelper) {}
  emitGoBack(): void {
    this.backClicked.emit();
    this.nav.back();
  }
  goToMenu(): void {
    const currentUrl = this.normalizeUrl(this.router.url);
    if (currentUrl === "/menu") {
      this.router.navigateByUrl("/", { skipLocationChange: true }).then(() => {
        this.router.navigate(["/menu"]).then(() => {
          this.nav.freshNavigation;
          this.toggleMenu.emit();
        });
      });
    } else {
      this.router.navigate(["/menu"]).then(() => {
        this.toggleMenu.emit();
      });
    }
  }

  private normalizeUrl(url: string): string {
    return url.split(/[?#]/)[0].replace(/\/+$/, "");
  }

  goToTicket(): void {
    this.router.navigate(["/tickets"]).then(() => {
      this.itemSelected.emit("tickets");
    });
  }
}
